/**
 * Form helpers for edit field event summary views.
 */
import type { EventSummary, UpdateEventSummaryDto } from '@/types/event-summary.types';
import { getErrorMessage } from '@/utils/errors-utils';

/** Hydrate the edit textarea from the current summary. */
export function initialEventSummaryContent(summary: EventSummary): string {
  return summary.content || '';
}

/** PATCH body — only `content` is writable on a summary. */
export function buildUpdateEventSummaryDto(content: string): UpdateEventSummaryDto {
  return { content };
}

/** Central error copy from {@link getErrorMessage}. */
export function getEventSummaryApiError(error: unknown, _fallback?: string): string {
  return getErrorMessage(error);
}
